import { Flex, Image, useMantineTheme } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import * as React from 'react';
import { Outlet } from 'react-router-dom';

import Loader from 'components/ui/Loader';
import { withNotAuth } from 'hocs/withNotAuth';
import { defaultAppConfig } from 'stores/global/RootStore/AppConfigStore';
import { useAppConfig } from 'stores/global/RootStore/context';
import { useDevices } from 'utils/devices';

import s from './LoginLayout.module.scss';

const LoginLayout: React.FC = () => {
  const theme = useMantineTheme();
  const { isPhone, isDesktop } = useDevices();

  const { images } = useAppConfig();

  return (
    <Flex className={s.root} align={isDesktop ? 'center' : 'flex-start'} justify={isDesktop ? 'center' : 'stretch'}>
      <Flex
        className={s.root__wrapper}
        justify={isDesktop ? 'space-between' : 'flex-end'}
        direction={isDesktop ? 'row' : 'column-reverse'}
      >
        <Flex className={s.root__content} direction="column" align="center">
          <Notifications position="top-center" limit={3} />
          {!isPhone && (
            <Image
              className={s.root__logo}
              src={images.logoUrl}
              style={{ maxWidth: images.logoWidth ?? defaultAppConfig.images.logoWidth }}
            />
          )}
          <React.Suspense fallback={<Loader fullHeight text={null} />}>
            <Outlet />
          </React.Suspense>
        </Flex>

        <div className={s['root__cover-wrapper']}>
          <picture className={s.root__cover}>
            {images.startImageUrlMobileWebp && (
              <source
                srcSet={images.startImageUrlMobileWebp}
                type="image/webp"
                media={`(max-width: ${theme.breakpoints.sm})`}
              />
            )}
            {images.startImageUrlMobile && (
              <source srcSet={images.startImageUrlMobile} media={`(max-width: ${theme.breakpoints.sm})`} />
            )}
            {images.startImageUrlTabletWebp && (
              <source
                srcSet={images.startImageUrlTabletWebp}
                type="image/webp"
                media={`(max-width: ${theme.breakpoints.md})`}
              />
            )}
            {images.startImageUrlTablet && (
              <source srcSet={images.startImageUrlTablet} media={`(max-width: ${theme.breakpoints.md})`} />
            )}
            {images.startImageUrlWebp && <source srcSet={images.startImageUrlWebp} type="image/webp" />}
            <img className={s['root__cover-src']} src={images.startImageUrl} alt="Фоновое изображение" />
          </picture>
          {isPhone && <Image className={s.root__logo} src={images.mobileLogoUrl} />}
        </div>
      </Flex>
    </Flex>
  );
};

export default withNotAuth(LoginLayout);
